// АВТОГЕНЕРИРОВАННЫЙ ФАЙЛ — НЕ РЕДАКТИРУЙТЕ ВРУЧНУЮ.
// Источник правды: data-source/korpy_balance_v6.xlsx
// Регенерация: npm run gen-cards (или двойной клик по tools/gen-cards.bat)
// Сгенерировано: 2026-06-03T21:08:21.158Z

export const cards = [
  {
    "id": "livlife_act_bio_cycle",
    "name_ru": "Био-цикл",
    "name_en": "Bio-Cycle",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Самый раненый союзник возвращается в свою колоду"
    },
    "dsl_order": {
      "target": "ally_lowest_hp",
      "effect": "return_to_deck",
      "value": "full_hp_full_armor"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Перерождение. Не выписка. Не смерть. Цикл.»",
    "ability_text_en": {
      "order": "The most wounded ally returns to its deck"
    }
  },
  {
    "id": "livlife_act_bio_kataklism",
    "name_ru": "Био-катаклизм",
    "name_en": "Bio-Cataclysm",
    "faction": "livlife",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все вражеские юниты получают 1 стак Заражения"
    },
    "dsl_order": {
      "target": "enemy_aoe_all",
      "effect": "infect",
      "value": "1"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Катаклизм — это масштабирование болезни.»",
    "ability_text_en": {
      "order": "All enemy units gain 1 Infection stack"
    }
  },
  {
    "id": "livlife_act_bio_oblako",
    "name_ru": "Био-облако",
    "name_en": "Bio-Cloud",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Накладывает 1 стак Заражения на 3 случайных вражеских юнитов"
    },
    "dsl_order": {
      "target": "enemy_aoe_random",
      "effect": "infect",
      "value": "1@count:3"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Облако распыляется. Воздух заражается. Контракты заключаются.»",
    "ability_text_en": {
      "order": "Applies 1 Infection stack to 3 random enemy units"
    }
  },
  {
    "id": "livlife_act_bio_protocol",
    "name_ru": "Био-протокол",
    "name_en": "Bio-Protocol",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзные юниты лечатся на 2 hp + один союзный юнит получает Скрытность до конца следующего хода"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "heal:2@ally_aoe_all|give_keyword:stealth@ally_choose",
      "duration": "until_end_of_next_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Стандартный протокол. Расширенная подписка.»",
    "ability_text_en": {
      "order": "All allied units heal 2 hp + one allied unit gains Stealth until the end of the next turn"
    }
  },
  {
    "id": "livlife_act_bio_razryv",
    "name_ru": "Био-разрыв",
    "name_en": "Bio-Burst",
    "faction": "livlife",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзные юниты лечатся на 3 hp + все союзники наносят 1 урон случайному вражескому юниту"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "heal:3@ally_aoe_all|damage:1@enemy_random_per_ally"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Хил всем. Удар всем. Двойная отчётность.»",
    "ability_text_en": {
      "order": "All allied units heal 3 hp + all allies deal 1 damage to a random enemy unit"
    }
  },
  {
    "id": "livlife_act_bio_reserv",
    "name_ru": "Био-резерв",
    "name_en": "Bio-Reserve",
    "faction": "livlife",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Воскресить 2 случайных юнита из своего сброса с 50% max hp на свободные ячейки"
    },
    "dsl_order": {
      "target": "own_discard_random_units",
      "effect": "resurrect",
      "value": "half_hp@own_empty_slots|count:2"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Резерв — это не запас. Это второй акт.»",
    "ability_text_en": {
      "order": "Resurrect 2 random units from your discard with 50% max hp to free slots"
    }
  },
  {
    "id": "livlife_act_bio_shield",
    "name_ru": "Био-щит",
    "name_en": "Bio-Shield",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +0/2/0 и Иммунитет"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "composite",
      "value": "buff_perm:0/2/0@ally_choose|give_keyword:immune_first_hit@ally_choose",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Щит — это инвестиция. Иммунитет — премия акционерам.»",
    "ability_text_en": {
      "order": "An ally gets +0/2/0 and Immune"
    }
  },
  {
    "id": "livlife_act_bio_stimulyator",
    "name_ru": "Био-стимулятор LL-K",
    "name_en": "Bio-stimulator LL-K",
    "faction": "livlife",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +0/0/3"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "buff_perm",
      "value": "0/0/3",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Корп-добавка. Без побочных эффектов. Зависимость не указана в инструкции.»",
    "ability_text_en": {
      "order": "An ally gets +0/0/3"
    }
  },
  {
    "id": "livlife_act_bio_stimulyator_llj",
    "name_ru": "Био-стимулятор LL-J",
    "name_en": "Bio-stimulator LL-J",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +2/0/0 и Пробитие до конца следующего хода"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "composite",
      "value": "buff_temp:2/0/0@ally_choose|give_keyword:pierce@ally_choose",
      "duration": "until_end_of_next_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Стим — это не препарат. Это контракт с собственной плотью.»",
    "ability_text_en": {
      "order": "An ally gets +2/0/0 and Pierce until the end of the next turn"
    }
  },
  {
    "id": "livlife_act_boevoy_stimpak",
    "name_ru": "Боевой стимпак",
    "name_en": "Combat Stimpack",
    "faction": "livlife",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзные юниты на поле получают +2/0/0 до конца следующего хода и -1 hp"
    },
    "dsl_order": {
      "target": "ally_aoe_all",
      "effect": "composite",
      "value": "buff_temp:2/0/0@ally_aoe_all|damage:1@ally_aoe_all",
      "duration": "until_end_of_next_turn"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Боль — это валюта. Премию ты получишь в гробу.»",
    "ability_text_en": {
      "order": "All allied units on the field get +2/0/0 until the end of the next turn and -1 hp"
    }
  },
  {
    "id": "livlife_act_chrezvychayny_protokol",
    "name_ru": "Чрезвычайный протокол",
    "name_en": "Emergency Protocol",
    "faction": "livlife",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзные юниты на поле полностью восстанавливают hp и броню + ставятся 3 случайные карты юнитов из колоды"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "heal_to_full:none@ally_aoe_all|summon_random_from_deck:count:3@own_empty_slots"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«ЧП. ЧП. ЧП. Каждый сигнал — премия.»",
    "ability_text_en": {
      "order": "All allied units on the field fully restore hp and armor + 3 random unit cards from the deck are deployed"
    }
  },
  {
    "id": "livlife_act_evakuatsionny_modul",
    "name_ru": "Эвакуационный модуль",
    "name_en": "Evacuation Module",
    "faction": "livlife",
    "type": "action",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все юниты возвращаются в руку. Усиления сохраняются"
    },
    "dsl_order": {
      "target": "ally_aoe_all",
      "effect": "return_to_hand",
      "value": "keep_buffs_full_restore"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Эвакуация — это перевозка активов между балансовыми отчётами.»",
    "ability_text_en": {
      "order": "All units return to hand. Buffs are kept"
    }
  },
  {
    "id": "livlife_act_kiber_implant_llk",
    "name_ru": "Кибер-имплант LL-K",
    "name_en": "Cyber-Implant LL-K",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Союзник получает +0/3/0"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "buff_perm",
      "value": "0/3/0",
      "duration": "permanent"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Хром. Сталь. Проводок куда нужно.»",
    "ability_text_en": {
      "order": "An ally gets +0/3/0"
    }
  },
  {
    "id": "livlife_act_pandemia",
    "name_ru": "Пандемия",
    "name_en": "Pandemic",
    "faction": "livlife",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все Зараженные юниты умирают"
    },
    "dsl_order": {
      "target": "enemy_infected_aoe",
      "effect": "destroy"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Эпидемия закончилась. Контракты подписаны.»",
    "ability_text_en": {
      "order": "All infected units die"
    }
  },
  {
    "id": "livlife_act_regeneratsia_protokol",
    "name_ru": "Регенерация-протокол",
    "name_en": "Regeneration Protocol",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Полностью лечит самого раненого союзника + лечит Героя на 4 hp"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "heal_to_full:none@ally_lowest_hp|heal:4@hero_self"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Главврач сначала лечит других. Потом — себя. Потом — счёт.»",
    "ability_text_en": {
      "order": "Fully heals the most wounded ally + heals the Hero for 4 hp"
    }
  },
  {
    "id": "livlife_act_standart_protokol",
    "name_ru": "Стандарт-протокол LL",
    "name_en": "LL Standard Protocol",
    "faction": "livlife",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Лечит выбранного союзника на 3 hp"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "heal",
      "value": "3"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Базовый пакет. Нерфоринит. Эффективен.»",
    "ability_text_en": {
      "order": "Heal a chosen ally for 3 hp"
    }
  },
  {
    "id": "livlife_act_triazh_protokol",
    "name_ru": "Триаж-протокол",
    "name_en": "Triage Protocol",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Все союзники на выбранной линии (1-я или 2-я) лечатся до максимума"
    },
    "dsl_order": {
      "target": "ally_aoe_chosen_line",
      "effect": "heal_to_full"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сначала тех, кто платит больше. Потом — тех, кто заплатит позже.»",
    "ability_text_en": {
      "order": "All allies on a chosen line (1 or 2) heal to maximum"
    }
  },
  {
    "id": "livlife_act_velikoe_voskreshenie",
    "name_ru": "Великое воскрешение",
    "name_en": "Great Resurrection",
    "faction": "livlife",
    "type": "action",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Воскресить всех юнитов из своего сброса с 50% max hp"
    },
    "dsl_order": {
      "target": "own_discard_all_units",
      "effect": "resurrect",
      "value": "half_hp@own_empty_slots"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Все возвращаются. Все платят. Никто не уходит.»",
    "ability_text_en": {
      "order": "Resurrect all units from your discard with 50% max hp"
    }
  },
  {
    "id": "livlife_act_voskreshenie_lazaro",
    "name_ru": "Воскрешение Lazaro",
    "name_en": "Lazaro Resurrection",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Воскресить случайного юнита из своего сброса с 50% max hp на свободную ячейку"
    },
    "dsl_order": {
      "target": "own_discard_random_unit",
      "effect": "resurrect",
      "value": "half_hp@random_empty_own_slot"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сброс — это просто временный простой.»",
    "ability_text_en": {
      "order": "Resurrect a random unit from your discard with 50% max hp to a free slot"
    }
  },
  {
    "id": "livlife_act_zabor_materiala",
    "name_ru": "Забор био-материала",
    "name_en": "Bio-Material Sample",
    "faction": "livlife",
    "type": "action",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Добор 1 карты + 1 урон выбранному союзному юниту"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "draw:1@self|damage:1@ally_choose"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Биопсия. Анализ. Контракт.»",
    "ability_text_en": {
      "order": "Draw 1 card + 1 damage to a chosen allied unit"
    }
  },
  {
    "id": "livlife_act_zapasnik_llk",
    "name_ru": "Запасник LL-K",
    "name_en": "LL-K Storage",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Добор 1 карты + перемещает случайную карту юнита из руки в свой сброс"
    },
    "dsl_order": {
      "target": "composite",
      "effect": "composite",
      "value": "draw:1@self|move_to_discard:hand_random_unit@self"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Списали в сброс. Не выбросили. Просто временно убрали.»",
    "ability_text_en": {
      "order": "Draw 1 card + move a random unit card from your hand to your discard"
    }
  },
  {
    "id": "livlife_act_zashifrovannaya_probirka",
    "name_ru": "Зашифрованная пробирка",
    "name_en": "Encrypted Vial",
    "faction": "livlife",
    "type": "action",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": null,
    "armor": null,
    "hp": null,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "Дай 3 стака Заражения на выбранного вражеского юнита"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "infect",
      "value": "3"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Состав засекречен. Эффект — открыт всем.»",
    "ability_text_en": {
      "order": "Apply 3 Infection stacks to a chosen enemy unit"
    }
  },
  {
    "id": "livlife_augment_stimpak",
    "name_ru": "Аугмент «Стимпак»",
    "name_en": "Augment \"Stimpack\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": 2,
    "armor": 1,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При исцелении получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_takes_heal",
      "filter": "self",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждый шприц — апгрейд. Каждый апгрейд — счёт.»",
    "ability_text_en": {
      "trigger": "When healed, gets +1/0/0"
    }
  },
  {
    "id": "livlife_augment_strelok",
    "name_ru": "Аугмент-стрелок",
    "name_en": "Augment Shooter",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 0,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Импланты в глазах. Винтовка во второй левой руке. Вопросов не задаёт.»"
  },
  {
    "id": "livlife_avangard_vita",
    "name_ru": "Авангард Vita",
    "name_en": "Vanguard Vita",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 2,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда союзный юнит лечится, получает +1/0/0 до конца игры, но не более +4/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_healed",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent",
      "condition": "stack_lt_4"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«За меня платят. Я бьюсь сильнее когда платят.»",
    "ability_text_en": {
      "trigger": "When an allied unit heals, gets +1/0/0 for the rest of the game, but no more than +4/0/0"
    }
  },
  {
    "id": "livlife_bio_agent_mor",
    "name_ru": "Био-агент «Мор»",
    "name_en": "Bio-agent \"Mor\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": 2,
    "armor": 0,
    "hp": 3,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "1 стак Заражения на выбранного вражеского юнита"
    },
    "dsl_order": {
      "target": "enemy_choose",
      "effect": "infect",
      "value": "1"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Мор — это не профессия. Это диагноз.»",
    "ability_text_en": {
      "order": "1 Infection stack on a chosen enemy unit"
    }
  },
  {
    "id": "livlife_bio_implant_ll9",
    "name_ru": "Био-имплант LL-9",
    "name_en": "Bio-Implant LL-9",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 2,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При получении урона получает +1/0/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_takes_damage",
      "filter": "self",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждый удар — данные. Каждый шрам — патент.»",
    "ability_text_en": {
      "trigger": "When it takes damage, gets +1/0/0"
    }
  },
  {
    "id": "livlife_bio_palach",
    "name_ru": "Био-палач",
    "name_en": "Bio-Executioner",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 3,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда убивает юнита, восстанавливает себе +0/0/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "killed_target",
      "target": "self",
      "effect": "heal",
      "value": "2"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Прибил. Доел. Записал в отчёт.»",
    "ability_text_en": {
      "trigger": "When it kills a unit, restores +0/0/2 to itself"
    }
  },
  {
    "id": "livlife_bio_strazh_ll3",
    "name_ru": "Био-страж LL-3",
    "name_en": "Bio-guard LL-3",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 2,
    "hp": 6,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Биоматериал на страже. Контракт на 5 лет. Лечится в той же клинике где работает.»"
  },
  {
    "id": "livlife_bio_terror_zero",
    "name_ru": "Био-террор «Зеро»",
    "name_en": "Bio-Terror \"Zero\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": 4,
    "armor": 2,
    "hp": 7,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "все вражеские юниты на выбранной линии получают 3 стака Заражения"
    },
    "dsl_order": {
      "target": "enemy_aoe_chosen_line",
      "effect": "infect",
      "value": "3"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Пациент Zero. Никаких симптомов. Только последствия.»",
    "ability_text_en": {
      "order": "All enemy units on a chosen line gain 3 Infection stacks"
    }
  },
  {
    "id": "livlife_boevoy_medik",
    "name_ru": "Боевой медик",
    "name_en": "Combat Medic",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": 2,
    "armor": 4,
    "hp": 3,
    "keywords": [],
    "priority_override": "strongest",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале хода лечит самого раненого юнита на 1 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "target": "ally_lowest_hp",
      "effect": "heal",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Раны лечит. Контракты заключает. Стреляет в первую очередь по самому опасному.»",
    "ability_text_en": {
      "trigger": "At the start of the turn, heals the most wounded unit for 1 hp"
    }
  },
  {
    "id": "livlife_doctor_chuma",
    "name_ru": "Доктор «Чума»",
    "name_en": "Doctor \"Plague\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": 2,
    "armor": 2,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При атаке +1 урон по целям с Заражением и накладывает 1 стак Заражения с каждым ударом"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "target": "composite",
      "effect": "composite",
      "value": "extra_damage_on_attack:1@target_if_infected|infect:1@unit_attack_target"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Прикоснулся. Проверил. Записал.»",
    "ability_text_en": {
      "trigger": "On attack, +1 damage to targets with Infected and applies 1 Infection stack with each hit"
    }
  },
  {
    "id": "livlife_doctor_regenus",
    "name_ru": "Доктор «Регенус»",
    "name_en": "Doctor \"Regenus\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": 2,
    "armor": 3,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При воскрешении юнита получает +1/0/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_resurrected",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "1/0/1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждый воскрешённый — данные. Данные — патенты. Патенты — деньги.»",
    "ability_text_en": {
      "trigger": "When a unit is resurrected, gets +1/0/1"
    }
  },
  {
    "id": "livlife_dron_lazaro",
    "name_ru": "Дрон Lazaro",
    "name_en": "Lazaro Drone",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 4,
    "keywords": [
      "stealth"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти союзного юнита на той же линии лечит самого раненого союзника на 1 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_died",
      "filter": "same_line",
      "target": "ally_lowest_hp",
      "effect": "heal",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Прилетает на смерть. Уходит с прибылью.»",
    "ability_text_en": {
      "trigger": "When an allied unit on the same line dies, heals the most wounded ally for 1 hp"
    }
  },
  {
    "id": "livlife_giper_hirurg_boytsovy",
    "name_ru": "Гипер-хирург «Бойцовый»",
    "name_en": "Hyper-Surgeon \"Fighter\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": 3,
    "armor": 2,
    "hp": 6,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда любой союзный юнит лечится - получает +0/0/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_healed",
      "target": "self",
      "effect": "buff_self_perm",
      "value": "0/0/1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждое чужое лечение — мой апгрейд. Чужая боль — моя сила.»",
    "ability_text_en": {
      "trigger": "When any allied unit heals, gets +0/0/1"
    }
  },
  {
    "id": "livlife_glavny_epidemiolog",
    "name_ru": "Главный эпидемиолог",
    "name_en": "Chief Epidemiologist",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": 2,
    "armor": 3,
    "hp": 6,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При смерти юнита с Заражением один союзный юнит получает +1/0/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "enemy_died",
      "filter": "died_while_infected",
      "target": "ally_random",
      "effect": "buff_perm",
      "value": "1/0/1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Каждая смерть — данные. Каждая статистика — премия.»",
    "ability_text_en": {
      "trigger": "When a unit with Infected dies, one allied unit gets +1/0/1"
    }
  },
  {
    "id": "livlife_glavny_medik_lazar",
    "name_ru": "Главный медик «Лазарь»",
    "name_en": "Chief Medic \"Lazarus\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": 2,
    "armor": 3,
    "hp": 6,
    "keywords": [
      "stealth"
    ],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "возвращает и исцеляет самого раненого юнита с поля в руку, а сам ставится на место ушедшего юнита.",
      "trigger": "В конце хода лечит на 3 hp одного союзника по приоритету лечения"
    },
    "dsl_order": {
      "target": "ally_lowest_hp",
      "effect": "composite",
      "value": "return_to_hand:keep_buffs_full_restore@ally_lowest_hp|place_self_at:event_subject_cell@self"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "3"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Уходит. Возвращается. Опять уходит. Корпорация платит за каждый раз.»",
    "ability_text_en": {
      "order": "Returns and heals the most wounded unit from the field to your hand, and takes the place of the departed unit.",
      "trigger": "At the end of the turn, heals 3 hp to one ally by heal priority"
    }
  },
  {
    "id": "livlife_hirurg_agressor_ostrie",
    "name_ru": "Хирург-агрессор «Острие»",
    "name_en": "Aggressor Surgeon \"Edge\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": 4,
    "armor": 1,
    "hp": 5,
    "keywords": [
      "pierce"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда атакует, то лечит самого раненого союзного юнита на 3 hp"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "ally_lowest_hp",
      "effect": "heal",
      "value": "3"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Атакую — лечу. Чужого режу — своих чиню. Это и есть медицина.»",
    "ability_text_en": {
      "trigger": "When it attacks, heals the most wounded allied unit for 3 hp"
    }
  },
  {
    "id": "livlife_hirurg_genetik_iskhak",
    "name_ru": "Хирург-генетик «Исхак»",
    "name_en": "Surgeon-Geneticist \"Iskhak\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": 3,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока юнит жив, все воскрешённые союзники получают \"Посмертный контракт\""
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "resurrected_unit",
      "target": "event_subject",
      "effect": "give_keyword",
      "keyword": "deathrattle_contract"
    },
    "flavor_ru": "«Один раз умер — повезло. Дважды — это уже статистика.»",
    "ability_text_en": {
      "aura": "While this unit is alive, all resurrected allies gain «Posthumous Contract»"
    }
  },
  {
    "id": "livlife_hirurg_ll7",
    "name_ru": "Хирург LL-7",
    "name_en": "Surgeon LL-7",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 0,
    "armor": 2,
    "hp": 6,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода лечит на 2 hp одного союзника по приоритету лечения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "2"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Двадцать лет в профессии. Семь имплантов в руках. Ни одной ошибки в счетах.»",
    "ability_text_en": {
      "trigger": "At the end of the turn, heals 2 hp to one ally by heal priority"
    }
  },
  {
    "id": "livlife_hirurg_skalpel",
    "name_ru": "Хирург-инвазивный «Скальпель»",
    "name_en": "Invasive Surgeon \"Scalpel\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": 3,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При атаке лечится на +0/0/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "unit_attack",
      "filter": "self",
      "target": "self",
      "effect": "heal",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Режу. Лечу себя. Режу опять.»",
    "ability_text_en": {
      "trigger": "On attack, heals itself +0/0/1"
    }
  },
  {
    "id": "livlife_hirurg_vita",
    "name_ru": "Хирург Vita",
    "name_en": "Surgeon Vita",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 0,
    "armor": 0,
    "hp": 6,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "order": "лечит союзного юнита по выбору на 2 hp"
    },
    "dsl_order": {
      "target": "ally_choose",
      "effect": "heal",
      "value": "2"
    },
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сделал шов. Выписал счёт. Ушёл к следующему.»",
    "ability_text_en": {
      "order": "Heals a chosen allied unit for 2 hp"
    }
  },
  {
    "id": "livlife_kapelnitsa",
    "name_ru": "Капельница",
    "name_en": "IV Drip",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": 0,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При воскрешении союзного юнита: +0/1/0 всем союзным юнитам на поле"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_resurrected",
      "target": "ally_aoe_all",
      "effect": "buff_stats",
      "value": "0/1/0",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Капля за каплей. Имплант за имплантом.»",
    "ability_text_en": {
      "trigger": "When an allied unit is resurrected: +0/1/0 to all allied units on the field"
    }
  },
  {
    "id": "livlife_kapsula_boya",
    "name_ru": "Капсула боя",
    "name_en": "Combat Capsule",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_zayn",
    "atk": 1,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Когда любой союзный юнит лечится, другой случайный союзный юнит получает +1/0/0 до конца следующего хода"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "ally_healed",
      "target": "ally_random_other",
      "effect": "buff_temp",
      "value": "1/0/0"
    },
    "flavor_ru": "«Капсула передаёт. Не лечит. Не стреляет. Только распределяет.»",
    "ability_text_en": {
      "aura": "When any allied unit heals, another random allied unit gets +1/0/0 until the end of the next turn"
    }
  },
  {
    "id": "livlife_kapsula_regeneratsii",
    "name_ru": "Капсула регенерации",
    "name_en": "Regeneration Capsule",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": 0,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Все союзные юниты в руке Лив Лайф получают +0/0/2 при следующем выставлении"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "target": "hand_units",
      "effect": "buff_perm_on_play",
      "value": "0/0/2"
    },
    "flavor_ru": "«Сначала контейнер. Потом тело. Потом контракт.»",
    "ability_text_en": {
      "aura": "All allied Liv Life units in your hand get +0/0/2 on their next deployment"
    }
  },
  {
    "id": "livlife_koordinator_vita",
    "name_ru": "Координатор Vita",
    "name_en": "Coordinator Vita",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": 2,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При розыгрыше юнита из руки лечит на 3 hp одного союзника по приоритету лечения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_summoned",
      "filter": "from_hand",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "3"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Координирую. Лечу. Отчитываюсь.»",
    "ability_text_en": {
      "trigger": "When a unit is played from hand, heals 3 hp to one ally by heal priority"
    }
  },
  {
    "id": "livlife_kurator_pandemia",
    "name_ru": "Куратор «Пандемия»",
    "name_en": "Curator \"Pandemic\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": 3,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "В начале хода каждый заражённый юнит получает +1 стак Заражения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "filter": "enemy_turn_start",
      "target": "enemy_infected_aoe",
      "effect": "infect",
      "value": "1",
      "condition": "stack_lt_3"
    },
    "flavor_ru": "«Я не лечу. Я наблюдаю распространение.»",
    "ability_text_en": {
      "aura": "At the start of the turn, each infected unit gains +1 Infection stack"
    }
  },
  {
    "id": "livlife_laborant_feniks",
    "name_ru": "Лаборант «Феникс»",
    "name_en": "Lab Tech \"Phoenix\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": 3,
    "armor": 3,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "При воскрешении союзного юнита этот воскрешённый юнит получает +1/1/1"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_resurrected",
      "target": "event_subject",
      "effect": "buff_perm",
      "value": "1/1/1",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сжёг. Восстановил. Усилил. Выписал тройной счёт.»",
    "ability_text_en": {
      "trigger": "When an allied unit is resurrected, that resurrected unit gets +1/1/1"
    }
  },
  {
    "id": "livlife_lekar_ll4",
    "name_ru": "Лекарь LL-4",
    "name_en": "Healer LL-4",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": 0,
    "armor": 2,
    "hp": 5,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода лечит на 3 hp одного союзника по приоритету лечения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "2"
    },
    "dsl_trigger2": {
      "event": "card_returned_to_hand",
      "target": "ally_random",
      "effect": "heal",
      "value": "1"
    },
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Что вернулось — то восстановилось. Что не вернулось — то списали.»",
    "ability_text_en": {
      "trigger": "At the end of the turn, heals 3 hp to one ally by heal priority"
    }
  },
  {
    "id": "livlife_medtekh_ll1",
    "name_ru": "Медтех LL-1",
    "name_en": "MedTech LL-1",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 0,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": "healer",
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода лечит на 1 hp одного союзника по приоритету лечения"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "ally_choose_priority",
      "effect": "heal",
      "value": "1"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Бинт. Шов. Подпись на форме страховки.»",
    "ability_text_en": {
      "trigger": "At the end of the turn, heals 1 hp to one ally by heal priority"
    }
  },
  {
    "id": "livlife_nositel_llv",
    "name_ru": "Носитель LL-V",
    "name_en": "Carrier LL-V",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_klod",
    "atk": 2,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "накладывает 1 стак Заражения на случайного вражеского юнита"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "enemy_random",
      "effect": "infect",
      "value": "1"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Болезнь — это не вирус. Болезнь — это передача.»",
    "ability_text_en": {
      "deathrattle": "Applies 1 Infection stack to a random enemy unit"
    }
  },
  {
    "id": "livlife_paramedik_ll2",
    "name_ru": "Парамедик LL-2",
    "name_en": "Paramedic LL-2",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Сорок секунд до приезда. Десять — на оценку. Тридцать — на расценку.»"
  },
  {
    "id": "livlife_podopytny_x7",
    "name_ru": "Подопытный X-7",
    "name_en": "Test Subject X-7",
    "faction": "livlife",
    "type": "unit",
    "rarity": "common",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 0,
    "hp": 5,
    "keywords": [
      "deathrattle_contract"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 3,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {},
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Семь итераций. Шесть смертей. Седьмой раз — не последний.»"
  },
  {
    "id": "livlife_pole_regeneratsii",
    "name_ru": "Поле регенерации",
    "name_en": "Regeneration Field",
    "faction": "livlife",
    "type": "unit",
    "rarity": "epic",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": 1,
    "armor": 4,
    "hp": 8,
    "keywords": [
      "taunt"
    ],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "aura": "Пока жив, все союзники на той же линии получают +0/2/2"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": {
      "target": "ally_aoe_same_line",
      "effect": "buff_stats",
      "value": "0/2/2"
    },
    "flavor_ru": "«Поле — это не просто территория. Это страховой кейс.»",
    "ability_text_en": {
      "aura": "While alive, all allies on the same line get +0/2/2"
    }
  },
  {
    "id": "livlife_prima_genetik_lazurnaya",
    "name_ru": "Прима-генетик «Лазурная»",
    "name_en": "Prime Geneticist \"Azure\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": 3,
    "armor": 3,
    "hp": 7,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В начале хода воскрешает случайного юнита из своего сброса на случайную свободную ячейку"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_start",
      "target": "own_discard_random_unit",
      "effect": "resurrect",
      "value": "full_hp@random_empty_own_slot"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Я — конец карьеры. И начало — каждое утро.»",
    "ability_text_en": {
      "trigger": "At the start of the turn, resurrects a random unit from your discard to a random free slot"
    }
  },
  {
    "id": "livlife_psikh",
    "name_ru": "Псих",
    "name_en": "Psycho",
    "faction": "livlife",
    "type": "unit",
    "rarity": "legendary",
    "archetype": null,
    "exclusive_hero": "livlife_ariana",
    "atk": 4,
    "armor": 3,
    "hp": 7,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 1,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "Когда любой союзник лечится, то наносит 3 урона случайному вражескому персонажу"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "ally_healed",
      "target": "enemy_random",
      "effect": "damage",
      "value": "3",
      "condition": "once_per_turn"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Когда другим становится лучше — кто-то должен платить. Это закон.»",
    "ability_text_en": {
      "trigger": "When any ally heals, deals 3 damage to a random enemy character"
    }
  },
  {
    "id": "livlife_regenerator_gidra",
    "name_ru": "Регенератор «Гидра»",
    "name_en": "Regenerator \"Hydra\"",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": null,
    "atk": 1,
    "armor": 1,
    "hp": 5,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "trigger": "В конце хода: лечит самого раненого союзного юнита на +0/0/2 и сам получает +0/1/0"
    },
    "dsl_order": null,
    "dsl_deathrattle": null,
    "dsl_trigger1": {
      "event": "turn_end",
      "target": "composite",
      "effect": "composite",
      "value": "heal:2@ally_lowest_hp|buff_self_perm:0/1/0@self",
      "duration": "permanent"
    },
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Отрубили голову. Выросло три. Два — ассистенты.»",
    "ability_text_en": {
      "trigger": "At the end of the turn: heals the most wounded allied unit +0/0/2 and gains +0/1/0 itself"
    }
  },
  {
    "id": "livlife_testirovshchik_mortis",
    "name_ru": "Тестировщик Mortis",
    "name_en": "Tester Mortis",
    "faction": "livlife",
    "type": "unit",
    "rarity": "rare",
    "archetype": null,
    "exclusive_hero": "livlife_lisa",
    "atk": 2,
    "armor": 1,
    "hp": 4,
    "keywords": [],
    "priority_override": null,
    "global_choices": [],
    "influence_cost": null,
    "mod_target": null,
    "initiation": null,
    "deck_limit": 2,
    "recycle_value": null,
    "nft_threshold": null,
    "price_usdt": null,
    "price_scripts": null,
    "ability_short": null,
    "ability_text": {
      "deathrattle": "при попадании в стопку сброса призывается его копия"
    },
    "dsl_order": null,
    "dsl_deathrattle": {
      "target": "own_discard",
      "effect": "add_extra_copy_to_discard",
      "value": "1"
    },
    "dsl_trigger1": null,
    "dsl_trigger2": null,
    "dsl_active": null,
    "dsl_aura": null,
    "flavor_ru": "«Один раз тест. Второй — контрольный. Третий — для отчёта.»",
    "ability_text_en": {
      "deathrattle": "When it enters the discard pile, a copy of it is summoned"
    }
  }
];
